import { doAjax } from './helper'

const navigation = () => {
	document.getElementById('previous-page')?.addEventListener('click', (e) => {
		e.preventDefault()
		document.getElementById('navigation')?.setAttribute('value', 'previous')
		doAjax({ 'previous_page': true }, (response) => {
			if (response?.success) {
				document.getElementById('loading-screen').classList.add('loading')
				location.href = location.href
			}
		})
	})
initBurgerMenu(); 
};

const initBurgerMenu = () => {
	const burgerIcon = document.getElementById('burger-menu-icon');
	const menuContent = document.getElementById('burger-menu-content');
	burgerIcon?.addEventListener('click', () => {
		if (menuContent.style.display === 'block') {
			menuContent.style.display = 'none';
		} else {
			menuContent.style.display = 'block';
		}
	});
};

export { navigation }